// ไฟล์: frontend/src/pages/UserDashboardPage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Chart, registerables } from 'chart.js';
import { Line, Doughnut } from 'react-chartjs-2';
import './DashboardPage.css';

// ลงทะเบียน Chart.js components ที่จำเป็น
Chart.register(...registerables);

const UserDashboardPage = ({ user }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get('/dashboard/user');
        setDashboardData(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        {/* <div className="loading-spinner">กำลังโหลดข้อมูล...</div> */}
      </div>
    );
  }

  if (!dashboardData) {
    return (
      <div className="dashboard-error">
        <h2>ไม่สามารถโหลดข้อมูลได้</h2>
        <p>เกิดข้อผิดพลาดในการโหลดข้อมูลแดชบอร์ด โปรดลองใหม่อีกครั้ง</p>
        <button onClick={() => window.location.reload()} className="btn btn-primary">
          <i className="fas fa-sync-alt"></i> โหลดใหม่
        </button>
      </div>
    );
  }

  const { counts, popularResources, badges } = dashboardData;

  // ข้อมูลสำหรับ Chart แสดงสัดส่วนประเภทเนื้อหา
  const contentData = {
    labels: ['สื่อการสอน', 'นวัตกรรม', 'บทความ'],
    datasets: [
      {
        data: [counts.resources, counts.innovations, counts.articles],
        backgroundColor: ['#3490dc', '#38c172', '#6574cd'],
        borderColor: ['#2779bd', '#1f9d55', '#5661b3'],
        borderWidth: 1,
      },
    ],
  };

  // ตัวเลือกสำหรับ Chart
  const doughnutOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'right',
      },
      title: {
        display: true,
        text: 'สัดส่วนประเภทเนื้อหา',
        font: {
          size: 16,
        },
      },
    },
    cutout: '70%',
  };

  return (
    <div className="dashboard-page">
      <div className="container">
        <div className="dashboard-header">
          <h1>
            <i className="fas fa-tachometer-alt"></i> แดชบอร์ดของฉัน
          </h1>
          <div className="dashboard-actions mb-3">
            <Link to="/upload-resource" className="btn btn-primary ml-3">
              <i className="fas fa-upload"></i> อัปโหลดสื่อ
            </Link>
            <Link to="/upload-innovation" className="btn btn-info ml-3">
              <i className="fas fa-lightbulb"></i> แชร์นวัตกรรม
            </Link>
            <Link to="/write-article" className="btn btn-secondary ml-3">
              <i className="fas fa-pen-fancy"></i> เขียนบทความ
            </Link>
          </div>
        </div>

        {/* สถิติ Cards */}
        <div className="stats-cards">
          <div className="stat-card primary">
            <i className="fas fa-file-alt"></i>
            <div className="stat-content">
              <div className="stat-value">{counts.resources}</div>
              <div className="stat-label">สื่อการสอน</div>
            </div>
          </div>
          <div className="stat-card success">
            <i className="fas fa-lightbulb"></i>
            <div className="stat-content">
              <div className="stat-value">{counts.innovations}</div>
              <div className="stat-label">นวัตกรรม</div>
            </div>
          </div>
          <div className="stat-card info">
            <i className="fas fa-pen-fancy"></i>
            <div className="stat-content">
              <div className="stat-value">{counts.articles}</div>
              <div className="stat-label">บทความ</div>
            </div>
          </div>
          <div className="stat-card warning">
            <i className="fas fa-bookmark"></i>
            <div className="stat-content">
              <div className="stat-value">{counts.libraryItems}</div>
              <div className="stat-label">รายการในคลัง</div>
            </div>
          </div>
        </div>

        <div className="dashboard-grid">
          {/* สื่อยอดนิยม */}
          <div className="dashboard-section">
            <div className="dashboard-card">
              <div className="dashboard-card-header">
                <h2>
                  <i className="fas fa-star"></i> สื่อยอดนิยมของคุณ
                </h2>
                <Link to="/resources" className="btn btn-sm btn-light">
                  <i className="fas fa-external-link-alt"></i> ดูทั้งหมด
                </Link>
              </div>
              <div className="dashboard-card-body">
                {popularResources.length > 0 ? (
                  <div className="popular-resources">
                    {popularResources.map((resource) => (
                      <div className="popular-resource" key={resource.id}>
                        <div className="popular-resource-image">
                          <img
                            src={
                              resource.thumbnail
                                ? `${process.env.REACT_APP_API_URL}/uploads/${resource.thumbnail}`
                                : '/assets/default-resource.jpg'
                            }
                            alt={resource.title} width={350} height={200}
                          />
                        </div>
                        <div className="popular-resource-info">
                          <Link to={`/resources/${resource.id}`} className="popular-resource-title">
                            {resource.title}
                          </Link>
                          <div className="popular-resource-stats">
                            <div className="popular-resource-stat">
                              <i className="fas fa-eye"></i> {resource.view_count} ครั้ง
                            </div>
                            <div className="popular-resource-stat">
                              <i className="fas fa-download"></i> {resource.download_count} ครั้ง
                            </div>
                            <div className="popular-resource-stat">
                              <i className="fas fa-star"></i> {typeof resource.avg_rating === 'number' ? resource.avg_rating.toFixed(1) : '0.0'}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-data-message">
                    <i className="fas fa-info-circle"></i> คุณยังไม่มีสื่อการสอน
                    <Link to="/upload-resource" className="btn btn-sm btn-primary ml-2">
                      <i className="fas fa-upload"></i> อัปโหลดเลย
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* สัดส่วนเนื้อหา */}
          <div className="dashboard-section">
            <div className="dashboard-card">
              <div className="dashboard-card-header">
                <h2>
                  <i className="fas fa-chart-pie"></i> สัดส่วนเนื้อหาของคุณ
                </h2>
              </div>
              <div className="dashboard-card-body">
                {counts.resources + counts.innovations + counts.articles > 0 ? (
                  <div className="chart-container">
                    <Doughnut data={contentData} options={doughnutOptions} />
                  </div>
                ) : (
                  <div className="no-data-message">
                    <i className="fas fa-info-circle"></i> คุณยังไม่มีเนื้อหา
                    <div className="mt-2">
                      <Link to="/upload-resource" className="btn btn-sm btn-primary mr-2">
                        <i className="fas fa-upload"></i> อัปโหลดสื่อ
                      </Link>
                      <Link to="/write-article" className="btn btn-sm btn-secondary">
                        <i className="fas fa-pen"></i> เขียนบทความ
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard-grid">
          {/* เหรียญรางวัล */}
          <div className="dashboard-section">
            <div className="dashboard-card">
              <div className="dashboard-card-header">
                <h2>
                  <i className="fas fa-medal"></i> เหรียญรางวัลที่ได้รับ
                </h2>
              </div>
              <div className="dashboard-card-body">
                {badges.length > 0 ? (
                  <div className="badges-grid">
                    {badges.map((badge) => (
                      <div className="badge-card" key={badge.id}>
                        <div className="badge-icon">
                          <i className={`fas fa-${badge.icon}`}></i>
                        </div>
                        <div className="badge-info">
                          <h3 className="badge-title">{badge.name}</h3>
                          <p className="badge-description">{badge.description}</p>
                          <div className="badge-date">
                            <i className="fas fa-calendar-alt"></i> ได้รับเมื่อ:{' '}
                            {new Date(badge.earned_at).toLocaleDateString('th-TH')}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-data-message">
                    <i className="fas fa-info-circle"></i> คุณยังไม่มีเหรียญรางวัล
                    <p className="mt-2">
                      แบ่งปันสื่อการสอนและนวัตกรรมที่มีคุณภาพเพื่อรับเหรียญรางวัล
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* สถิติผู้ติดตาม */}
          <div className="dashboard-section">
            <div className="dashboard-card">
              <div className="dashboard-card-header">
                <h2>
                  <i className="fas fa-users"></i> สถิติการติดตาม
                </h2>
              </div>
              <div className="dashboard-card-body">
                <div className="follow-stats">
                  <div className="follow-stat">
                    <div className="follow-icon">
                      <i className="fas fa-user-friends"></i>
                    </div>
                    <div className="follow-info">
                      <div className="follow-value">{counts.followers}</div>
                      <div className="follow-label">ผู้ติดตาม</div>
                    </div>
                  </div>
                  <div className="follow-stat">
                    <div className="follow-icon">
                      <i className="fas fa-user-plus"></i>
                    </div>
                    <div className="follow-info">
                      <div className="follow-value">{counts.following}</div>
                      <div className="follow-label">กำลังติดตาม</div>
                    </div>
                  </div>
                </div>
                <div className="text-center mt-3">
                  <Link to={`/teachers/${user.id}`} className="btn btn-primary">
                    <i className="fas fa-user"></i> ดูโปรไฟล์ของฉัน
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ลิงก์ด่วน */}
        <div className="dashboard-section">
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h2>
                <i className="fas fa-bolt"></i> ลิงก์ด่วน
              </h2>
            </div>
            <div className="dashboard-card-body">
              <div className="quick-links">
                <Link to="/library" className="quick-link">
                  <i className="fas fa-bookmark ml-3"></i>
                  <span>คลังส่วนตัว</span>
                </Link>
                <Link to="/profile" className="quick-link">
                  <i className="fas fa-user-edit ml-3"></i>
                  <span>แก้ไขโปรไฟล์</span>
                </Link>
                <Link to="/upload-resource" className="quick-link">
                  <i className="fas fa-upload ml-3"></i>
                  <span>อัปโหลดสื่อ</span>
                </Link>
                <Link to="/upload-innovation" className="quick-link">
                  <i className="fas fa-lightbulb ml-3"></i>
                  <span>แชร์นวัตกรรม</span>
                </Link>
                <Link to="/write-article" className="quick-link">
                  <i className="fas fa-pen-fancy ml-3"></i>
                  <span>เขียนบทความ</span>
                </Link>
                <Link to="/resources" className="quick-link">
                  <i className="fas fa-search ml-3"></i>
                  <span>ค้นหาสื่อ</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboardPage;
